var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "w-full md:w-1/2 mb-16 px-6" }, [
    _vm.event.image
      ? _c("div", [
          _vm.event.private
            ? _c(
                "span",
                {
                  staticClass:
                    "absolute bg-blue-gradient uppercase m-2 px-2 py-1 text-base rounded",
                },
                [_vm._v("Private Event")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.showEventDetail.apply(null, arguments)
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  src: _vm.event.image + "?auto=format&fit=crop&h=619&w=1024",
                },
              }),
            ]
          ),
        ])
      : _c("div", [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.showEventDetail.apply(null, arguments)
                },
              },
            },
            [
              _c("img", {
                attrs: { alt: "", src: "/img/hems-event-holder.png" },
              }),
            ]
          ),
        ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex justify-between" }, [
      _vm.published
        ? _c("div", { staticClass: "uppercase text-base text-gray-darker" }, [
            _vm._v("Published"),
          ])
        : _c(
            "div",
            [
              _vm.status == "new"
                ? [
                    _c(
                      "span",
                      { staticClass: "text-red text-base uppercase" },
                      [_vm._v("Draft")]
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.status == "needs review"
                ? [
                    _c(
                      "span",
                      { staticClass: "text-red text-base uppercase" },
                      [_vm._v("In Review")]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
      _vm._v(" "),
      _c("div", { staticClass: "flex relative" }, [
        _vm.event.published
          ? _c(
              "button",
              {
                staticClass: "flex flex-col mr-2",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.visitPublicUrl.apply(null, arguments)
                  },
                  mouseover: function ($event) {
                    _vm.hoverLink = true
                  },
                  mouseleave: function ($event) {
                    _vm.hoverLink = false
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "24",
                      height: "24",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c(
                      "g",
                      { attrs: { fill: "none", "fill-rule": "evenodd" } },
                      [
                        _c("path", {
                          attrs: {
                            d: "M11.695 9.04a.562.562 0 00-.725.313.584.584 0 00.307.743c.53.228 1.004.542 1.394.942 1.646 1.684 1.646 4.425 0 6.11l-3.374 3.454a4.08 4.08 0 01-2.984 1.256c-1.144 0-2.176-.457-2.984-1.256-1.646-1.685-1.646-4.425 0-6.11l3.374-3.454a.561.561 0 000-.8.53.53 0 00-.78 0l-3.375 3.455c-2.064 2.113-2.064 5.596 0 7.708A5.234 5.234 0 006.313 23a5.234 5.234 0 003.765-1.599l3.374-3.454c2.064-2.113 2.064-5.596 0-7.709a5.383 5.383 0 00-1.757-1.199",
                            fill: "#000",
                          },
                        }),
                        _c("path", {
                          attrs: {
                            d: "M11.695 9.04a.562.562 0 00-.725.313.584.584 0 00.307.743c.53.228 1.004.542 1.394.942 1.646 1.684 1.646 4.425 0 6.11l-3.374 3.454a4.08 4.08 0 01-2.984 1.256c-1.144 0-2.176-.457-2.984-1.256-1.646-1.685-1.646-4.425 0-6.11l3.374-3.454a.561.561 0 000-.8.53.53 0 00-.78 0l-3.375 3.455c-2.064 2.113-2.064 5.596 0 7.708A5.234 5.234 0 006.313 23a5.234 5.234 0 003.765-1.599l3.374-3.454c2.064-2.113 2.064-5.596 0-7.709a5.383 5.383 0 00-1.757-1.199z",
                            stroke: "#000",
                            "stroke-width": ".5",
                          },
                        }),
                        _c("path", {
                          attrs: {
                            d: "M21.437 2.6A5.205 5.205 0 0017.685 1c-1.418 0-2.752.571-3.78 1.6l-3.363 3.457c-2.056 2.114-2.056 5.6 0 7.714.5.515 1.084.915 1.751 1.2a.596.596 0 00.223.029c.222 0 .444-.114.528-.343a.586.586 0 00-.306-.743c-.528-.2-1-.543-1.39-.943-1.64-1.685-1.64-4.428 0-6.114L14.711 3.4c.806-.8 1.834-1.257 2.974-1.257 1.14 0 2.168.428 2.974 1.257 1.64 1.686 1.64 4.429 0 6.114l-3.363 3.457a.563.563 0 000 .8.527.527 0 00.778 0l3.363-3.457c2.084-2.114 2.084-5.6 0-7.714",
                            fill: "#000",
                          },
                        }),
                        _c("path", {
                          attrs: {
                            d: "M21.437 2.6A5.205 5.205 0 0017.685 1c-1.418 0-2.752.571-3.78 1.6l-3.363 3.457c-2.056 2.114-2.056 5.6 0 7.714.5.515 1.084.915 1.751 1.2a.596.596 0 00.223.029c.222 0 .444-.114.528-.343a.586.586 0 00-.306-.743c-.528-.2-1-.543-1.39-.943-1.64-1.685-1.64-4.428 0-6.114L14.711 3.4c.806-.8 1.834-1.257 2.974-1.257 1.14 0 2.168.428 2.974 1.257 1.64 1.686 1.64 4.429 0 6.114l-3.363 3.457a.563.563 0 000 .8.527.527 0 00.778 0l3.363-3.457c2.084-2.114 2.084-5.6 0-7.714z",
                            stroke: "#000",
                            "stroke-width": ".5",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.hoverLink
          ? _c(
              "span",
              {
                staticClass:
                  "bg-grey-light py-1 px-3 absolute pin-r button-duplicate whitespace-no-wrap mr-8",
              },
              [_vm._v("View Published Page")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "flex flex-col",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.showEventDuplicate.apply(null, arguments)
              },
              mouseover: function ($event) {
                _vm.hover = true
              },
              mouseleave: function ($event) {
                _vm.hover = false
              },
            },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  height: "24px",
                  width: "24px",
                  fill: "#000000",
                  "xmlns:dc": "http://purl.org/dc/elements/1.1/",
                  "xmlns:cc": "http://creativecommons.org/ns#",
                  "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
                  "xmlns:svg": "http://www.w3.org/2000/svg",
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:sodipodi":
                    "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
                  "xmlns:inkscape":
                    "http://www.inkscape.org/namespaces/inkscape",
                  version: "1.1",
                  x: "0px",
                  y: "0px",
                  viewBox: "0 0 100 100",
                },
              },
              [
                _c("g", { attrs: { transform: "translate(0,-952.36218)" } }, [
                  _c("path", {
                    staticStyle: {
                      "font-size": "medium",
                      "font-style": "normal",
                      "font-variant": "normal",
                      "font-weight": "normal",
                      "font-stretch": "normal",
                      "text-indent": "0",
                      "text-align": "start",
                      "text-decoration": "none",
                      "line-height": "normal",
                      "letter-spacing": "normal",
                      "word-spacing": "normal",
                      "text-transform": "none",
                      direction: "ltr",
                      "block-progression": "tb",
                      "writing-mode": "lr-tb",
                      "text-anchor": "start",
                      "baseline-shift": "baseline",
                      opacity: "1",
                      color: "#000000",
                      fill: "#000000",
                      "fill-opacity": "1",
                      stroke: "none",
                      "stroke-width": "6",
                      marker: "none",
                      visibility: "visible",
                      display: "inline",
                      overflow: "visible",
                      "enable-background": "accumulate",
                      "font-family": "Sans",
                      "-inkscape-font-specification": "Sans",
                    },
                    attrs: {
                      d: "M 27.6875 5 A 3.0003 3.0003 0 0 0 25 8 L 25 25 L 8 25 A 3.0003 3.0003 0 0 0 5 28 L 5 92 A 3.0003 3.0003 0 0 0 8 95 L 72 95 A 3.0003 3.0003 0 0 0 75 92 L 75 75 L 92 75 A 3.0003 3.0003 0 0 0 95 72 L 95 8 A 3.0003 3.0003 0 0 0 92.3125 5 A 3.0003 3.0003 0 0 0 92 5 L 28 5 A 3.0003 3.0003 0 0 0 27.6875 5 z M 31 11 L 89 11 L 89 69 L 75 69 L 75 28 A 3.0003 3.0003 0 0 0 72.3125 25 A 3.0003 3.0003 0 0 0 72 25 L 31 25 L 31 11 z M 11 31 L 69 31 L 69 89 L 11 89 L 11 31 z ",
                      transform: "translate(0,952.36218)",
                    },
                  }),
                ]),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _vm.hover
          ? _c(
              "span",
              {
                staticClass:
                  "bg-grey-light py-1 px-3 absolute pin-r button-duplicate",
              },
              [_vm._v("Duplicate")]
            )
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("h2", { staticClass: "text-1xl leading-tight mb-2 mt-1" }, [
      _c(
        "a",
        {
          staticClass:
            "text-n-gray-dark font-sans no-underline hover:underline",
          attrs: { href: "#" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.showEventDetail.apply(null, arguments)
            },
          },
        },
        [_vm._v("\n          " + _vm._s(_vm.event.title) + "\n        ")]
      ),
    ]),
    _vm._v(" "),
    _vm.event.hostName
      ? _c("div", { staticClass: "font-sans-italic mb-1 hosted-by" }, [
          _vm._v("\n        Hosted by "),
          _c("span", {
            staticClass: "font-sans-bold-italic",
            domProps: { innerHTML: _vm._s(_vm.event.hostName) },
          }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", {
      staticClass: "text-base mb-5",
      domProps: { innerHTML: _vm._s(_vm.event.teaser) },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "uppercase" }, [
      _c("div", { staticClass: "text-base font-sans-bold" }, [
        _vm._v(_vm._s(_vm._f("moment")(_vm.event.start_at, "ddd. MMMM DD"))),
      ]),
      _vm._v(" "),
      _vm.event.venue
        ? _c("div", { staticClass: "text-2xl leading-tight font-sans-bold" }, [
            _vm._v("@"),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.event.venue
      ? _c("div", { staticClass: "text-base" }, [
          _vm.event.venue.url && _vm.event.type !== "physical"
            ? _c("div", [
                _c(
                  "a",
                  { attrs: { target: "_blank", href: _vm.event.venue.url } },
                  [_vm._v(_vm._s(_vm.event.venue.name))]
                ),
                _c("br"),
              ])
            : _c("div", [
                _vm._v(
                  "\n            " + _vm._s(_vm.event.venue.name) + "\n        "
                ),
              ]),
          _vm._v("\n        " + _vm._s(_vm.event.venue.address_1)),
          _c("br"),
          _vm._v(" "),
          _vm.event.venue.city
            ? _c("span", [
                _vm._v(
                  _vm._s(_vm.event.venue.city) +
                    ", " +
                    _vm._s(_vm.event.venue.state) +
                    " " +
                    _vm._s(_vm.event.venue.zip)
                ),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "text-base" }, [
      _vm._v(
        "\n        " +
          _vm._s(_vm._f("moment")(_vm.event.start_at, "h:mm")) +
          "-" +
          _vm._s(_vm._f("moment")(_vm.event.end_at, "h:mm A")) +
          "\n    "
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }